import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { serve, Url } from './config';

@Injectable({
    providedIn: 'root'
})
export class ConfigsService {
    public config: any;
    public loadFinished: EventEmitter<boolean> = new EventEmitter();
    public constructor(private http: HttpClient) {
        this.http.get('/assets/global_config.json').subscribe( res => {
            this.config = res;
            this.loadFinished.emit(true);
        });
    }

    public exportServer(def: Url) {
        if (this.config.apiUrl) {
            const patten = /(http|https)\:\/\/([\w\W]*[^\/])\/?/;
            return `${def.protocol}://${patten.exec(this.config.apiUrl)[2].trim()}/`;
        } else {
            return serve(def);
        }
    }

    public exportComponent() {
        if (this.config.component) {
            return this.config.component;
        } else {
            return null;
        }
    }
}
